/* ============================================================
   Volare: on-screen autoplay manager.

   Long pages with several autoplay videos hit mobile browsers' limit on how many
   videos can play at once — so some "just stop playing", and videos paused when
   scrolled off-screen don't resume on their own.

   Fix: play each autoplay video only while it's on screen, and pause it when it
   scrolls away (frees the browser to play the next one). Excludes the product
   media gallery, which manages its own playback.
   ============================================================ */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        v.dataset.vlOnScreen = entry.isIntersecting ? '1' : '';
        if (entry.isIntersecting) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          try { v.pause(); } catch (e) {}
        }
      });
    },
    { threshold: 0.2 }
  );

  /* SAFETY NET: these are background loops with no controls — if one gets
     paused while still on screen (e.g. a load()/reset from other code), it
     would otherwise freeze forever, because the observer only fires on
     visibility CHANGES. Catch the pause and restart it. */
  function keepAlive(v) {
    v.addEventListener('pause', function () {
      if (v.dataset.vlOnScreen === '1' && !v.ended) {
        setTimeout(function () {
          if (v.dataset.vlOnScreen === '1' && v.paused && !v.ended) {
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          }
        }, 150);
      }
    });
  }

  function isGalleryVideo(v) {
    return !!(
      v.closest('.product__media-list') ||
      v.closest('.thumbnail-list') ||
      v.closest('.thumbnail')
    );
  }

  function observeAll(root) {
    /* data-vl-autoplay = deferred autoplay: no `autoplay` attr (so the browser
       doesn't download the file up-front), preload="none"; we start playback
       here when the video scrolls into view. */
    (root || document).querySelectorAll('video[autoplay], video[data-vl-autoplay]').forEach(function (v) {
      if (v.dataset.vlAutoplayManaged === '1') return;
      if (isGalleryVideo(v)) return;
      v.dataset.vlAutoplayManaged = '1';
      keepAlive(v);
      io.observe(v);
    });
  }

  function init() {
    observeAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Theme editor: re-scan when a section is (re)loaded. */
  document.addEventListener('shopify:section:load', function (e) {
    observeAll(e.target);
  });
})();
